module.exports = __webpack_public_path__ + "static/media/question.aed29d0f.png";